<template>
  <div class="form-page">
    <div class="page-header">
      <h1>Relatório de Atividades</h1>
      <p>Preenchimento operacional conforme o modelo selecionado.</p>
    </div>

    <div class="form-card">
      <h2>Identificação</h2>

      <div class="form-grid cols-3">
        <div class="form-group">
          <label>Modelo</label>
          <select v-model="form.idmodelo">
            <option value="">Selecione</option>
            <option v-for="item in lsModelos" :key="item.id" :value="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>SIM</label>
          <select v-model="form.idsim">
            <option value="">Selecione</option>
            <option v-for="item in lsSim" :key="item.id" :value="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Estabelecimento</label>
          <select v-model="form.idestabelecimento">
            <option value="">Selecione</option>
            <option v-for="item in lsEstabelecimentos" :key="item.id" :value="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Responsável</label>
          <select v-model="form.idusuario">
            <option value="">Selecione</option>
            <option v-for="item in lsUsuarios" :key="item.id" :value="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Período Inicial</label>
          <input v-model="form.dtinicial" type="date" />
        </div>

        <div class="form-group">
          <label>Período Final</label>
          <input v-model="form.dtfinal" type="date" />
        </div>
      </div>

      <div class="form-actions-inline">
        <button type="button" class="btn btn-primary">
          Buscar Atividades do Período
        </button>
      </div>
    </div>

    <div class="form-card">
      <h2>Atividades Vinculadas</h2>

      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th>Estabelecimento</th>
              <th>Selecionado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="atividade in lsAtividades" :key="atividade.id">
              <td>{{ atividade.data }}</td>
              <td>{{ atividade.tipo }}</td>
              <td>{{ atividade.descricao }}</td>
              <td>{{ atividade.estabelecimento }}</td>
              <td>
                <input v-model="atividade.selecionado" type="checkbox" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="form-card">
      <h2>Campos do Relatório</h2>

      <div class="campos-dinamicos">
        <template v-for="campo in camposModeloAtivo" :key="campo.id">
          <div
            class="form-group"
            :class="{
              'span-2': campo.largura === '100',
              'span-1': campo.largura === '50'
            }"
          >
            <label>{{ campo.label }}</label>

            <input
              v-if="campo.tipo === 'text'"
              v-model="valores[campo.nome]"
              type="text"
              :placeholder="campo.placeholder || ''"
            />

            <textarea
              v-else-if="campo.tipo === 'textarea'"
              v-model="valores[campo.nome]"
              rows="4"
              :placeholder="campo.placeholder || ''"
            ></textarea>

            <input
              v-else-if="campo.tipo === 'date'"
              v-model="valores[campo.nome]"
              type="date"
            />

            <input
              v-else-if="campo.tipo === 'number'"
              v-model="valores[campo.nome]"
              type="number"
            />

            <select
              v-else-if="campo.tipo === 'boolean'"
              v-model="valores[campo.nome]"
            >
              <option value="">Selecione</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>

            <select
              v-else-if="campo.tipo === 'select'"
              v-model="valores[campo.nome]"
            >
              <option value="">Selecione</option>
              <option v-for="opcao in campo.opcoes" :key="opcao" :value="opcao">
                {{ opcao }}
              </option>
            </select>

            <div v-else-if="campo.tipo === 'checklist'" class="checklist-box">
              <label v-for="opcao in campo.opcoes" :key="opcao" class="check-item">
                <input
                  type="checkbox"
                  :value="opcao"
                  v-model="valores[campo.nome]"
                />
                {{ opcao }}
              </label>
            </div>

            <input
              v-else-if="campo.tipo === 'anexo'"
              type="file"
            />

            <div v-else-if="campo.tipo === 'assinatura'" class="assinatura-box">
              <span>Campo reservado para assinatura digital</span>
              <button type="button" class="btn btn-secondary">Assinar</button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="form-card">
      <h2>Observações Gerais</h2>

      <div class="form-group">
        <textarea
          v-model="form.observacoes"
          rows="5"
          placeholder="Informe observações complementares do relatório"
        ></textarea>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="btn btn-secondary">Cancelar</button>
      <button type="button" class="btn btn-secondary">Salvar Rascunho</button>
      <button type="button" class="btn btn-primary">Finalizar Relatório</button>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue';

const lsModelos = [
  { id: 1, nome: 'Relatório de Atividades Padrão' },
  { id: 2, nome: 'Relatório de Atividades Complementar' },
];

const lsSim = [
  { id: 1, nome: 'SIM Central' },
  { id: 2, nome: 'SIM Regional' },
];

const lsEstabelecimentos = [
  { id: 1, nome: 'Frigorífico Exemplo' },
  { id: 2, nome: 'Laticínio Modelo' },
];

const lsUsuarios = [
  { id: 1, nome: 'João da Silva' },
  { id: 2, nome: 'Maria Souza' },
];

const lsAtividades = reactive([
  {
    id: 1,
    data: '2026-03-15',
    tipo: 'Vistoria',
    descricao: 'Vistoria periódica nas instalações',
    estabelecimento: 'Frigorífico Exemplo',
    selecionado: true,
  },
  {
    id: 2,
    data: '2026-03-16',
    tipo: 'Coleta',
    descricao: 'Coleta de amostra de produto',
    estabelecimento: 'Laticínio Modelo',
    selecionado: true,
  },
  {
    id: 3,
    data: '2026-03-17',
    tipo: 'Visita',
    descricao: 'Visita técnica de acompanhamento',
    estabelecimento: 'Frigorífico Exemplo',
    selecionado: false,
  },
]);

const form = reactive({
  idmodelo: 1,
  idsim: '',
  idestabelecimento: '',
  idusuario: '',
  dtinicial: '',
  dtfinal: '',
  observacoes: '',
});

const modelo1Campos = [
  {
    id: 1,
    nome: 'objetivo',
    label: 'Objetivo',
    tipo: 'textarea',
    largura: '100',
    placeholder: 'Informe o objetivo do relatório',
  },
  {
    id: 2,
    nome: 'situacaoEncontrada',
    label: 'Situação Encontrada',
    tipo: 'textarea',
    largura: '100',
    placeholder: 'Descreva a situação encontrada',
  },
  {
    id: 3,
    nome: 'houveIrregularidade',
    label: 'Houve Irregularidade?',
    tipo: 'boolean',
    largura: '50',
  },
  {
    id: 4,
    nome: 'classificacao',
    label: 'Classificação',
    tipo: 'select',
    largura: '50',
    opcoes: ['Conforme', 'Não Conforme', 'Parcialmente Conforme'],
  },
  {
    id: 5,
    nome: 'medidasAdotadas',
    label: 'Medidas Adotadas',
    tipo: 'textarea',
    largura: '100',
    placeholder: 'Informe as medidas adotadas',
  },
  {
    id: 6,
    nome: 'anexos',
    label: 'Anexos',
    tipo: 'anexo',
    largura: '100',
  },
  {
    id: 7,
    nome: 'assinaturaResponsavel',
    label: 'Assinatura do Responsável',
    tipo: 'assinatura',
    largura: '100',
  },
];

const modelo2Campos = [
  {
    id: 1,
    nome: 'atividadeComplementar',
    label: 'Atividade Complementar',
    tipo: 'text',
    largura: '100',
    placeholder: 'Descreva a atividade complementar',
  },
  {
    id: 2,
    nome: 'detalhamento',
    label: 'Detalhamento',
    tipo: 'textarea',
    largura: '100',
    placeholder: 'Informe os detalhes da atividade complementar',
  },
  {
    id: 3,
    nome: 'itensVerificados',
    label: 'Itens Verificados',
    tipo: 'checklist',
    largura: '100',
    opcoes: ['Documentação', 'Estrutura', 'Equipamentos', 'Higiene', 'Fluxo Operacional'],
  },
  {
    id: 4,
    nome: 'dataConclusao',
    label: 'Data de Conclusão',
    tipo: 'date',
    largura: '50',
  },
  {
    id: 5,
    nome: 'assinaturaResponsavel',
    label: 'Assinatura do Responsável',
    tipo: 'assinatura',
    largura: '100',
  },
];

const camposModeloAtivo = computed(() => {
  if (Number(form.idmodelo) === 2) return modelo2Campos;
  return modelo1Campos;
});

const valores = reactive({
  objetivo: '',
  situacaoEncontrada: '',
  houveIrregularidade: '',
  classificacao: '',
  medidasAdotadas: '',
  atividadeComplementar: '',
  detalhamento: '',
  itensVerificados: [],
  dataConclusao: '',
  assinaturaResponsavel: '',
});
</script>

<style scoped>
.form-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h1 {
  margin: 0 0 6px;
  font-size: 28px;
}

.page-header p {
  margin: 0;
  color: #666;
}

.form-card {
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}

.form-card h2 {
  margin: 0 0 16px;
  font-size: 20px;
}

.form-grid {
  display: grid;
  gap: 14px;
}

.form-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  border: 1px solid #cfcfcf;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #3b82f6;
}

.form-actions-inline {
  margin-top: 16px;
}

.table-wrap {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #e5e5e5;
  padding: 10px;
  text-align: left;
}

.table th {
  background: #f7f7f7;
}

.campos-dinamicos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.span-2 {
  grid-column: span 2;
}

.span-1 {
  grid-column: span 1;
}

.checklist-box {
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
}

.check-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.assinatura-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px dashed #c7c7c7;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  border: 0;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111827;
}

@media (max-width: 900px) {
  .form-grid.cols-3,
  .campos-dinamicos {
    grid-template-columns: 1fr;
  }

  .span-2,
  .span-1 {
    grid-column: span 1;
  }
}
</style>